const isValidVertex = (vertex: unknown): vertex is [number, number] =>
  Array.isArray(vertex) &&
  vertex.length >= 2 &&
  typeof vertex[0] === "number" &&
  typeof vertex[1] === "number";

/**
 * Ray-casting point-in-polygon test for normalized [0,1] coordinates.
 */
export const isPointInNormalizedPolygon = (
  polygon: number[][],
  point: [number, number]
): boolean => {
  const [x, y] = point;
  let isInside = false;
  let j = polygon.length - 1;

  for (let i = 0; i < polygon.length; i++) {
    const pi = polygon[i];
    const pj = polygon[j];
    if (!isValidVertex(pi) || !isValidVertex(pj)) {
      j = i;
      continue;
    }
    const [xi, yi] = pi;
    const [xj, yj] = pj;

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
    j = i;
  }

  return isInside;
};
